import React from "react";
import "./pagination-buttons-block.scss";
import PaginationButton from "./pagination-button";
import ArrowButton from "./arrow-button";

const PaginationButtonsBlock = ({
  pageNumber = 1,
  maxPageNumber,
  onButtonClick = () => { },
  onArrowClick = () => { }
}) => {

  return (
    <div className="pagination-block">
      <ArrowButton isDisabled={pageNumber === 1} onClick={() => { onArrowClick(false); }} />
      <ButtonsBlock maxPageNumber={maxPageNumber} pageNumber={pageNumber} onClick={onButtonClick} />
      <ArrowButton toRight isDisabled={pageNumber === maxPageNumber} onClick={onArrowClick} />

    </div>
  );
};

export default PaginationButtonsBlock;


const ButtonsBlock = ({ maxPageNumber = 10, pageNumber = 1, onClick = () => { } }) => {
  const buttons = [];

  for (let i = 1; i <= maxPageNumber; i++) {
    buttons.push(<PaginationButton number={i} isSelected={pageNumber === i} onClick={() => { onClick(i); }} />);
  }

  return buttons;
}